import { render } from "./GameFrame.vue?vue&type=template&id=0fed2b80&scoped=true"
import script from "./GameFrame.vue?vue&type=script&lang=js"
export * from "./GameFrame.vue?vue&type=script&lang=js"

import "./GameFrame.vue?vue&type=style&index=0&id=0fed2b80&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fed2b80"]])

export default __exports__